import styled from "styled-components/macro"
import { mobile, tablet } from "../styles/responsive"

export const Container = styled.div`
  height: 30px;
  background-color: #4c87ef;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  ${mobile({ textAlign: "center", justifyContent: "center" })}
`
export const Contact = styled.div`
  display: flex;
`
export const Info = styled.p`
  margin: 0 15px;
  ${tablet({
    margin: "0",
    fontSize: "15px",
  })}
`
export const SpecialOffer = styled.p`
  color: white;
  font-size: 20px;
  ${mobile({
    display: "none",
  })}
  ${tablet({
    fontSize: "18px",
  })}
`
